import {types} from './types';

const setGetReplenishmentReportAction = (payload) => {
    return {
        type: types.SET_REPLENISHMENT_REPORT,
        payload,
      }
}

export {
  setGetReplenishmentReportAction
}
